import { Navigate } from "react-router-dom";

import Login from "pages/Authentication/Login";
import Logout from "pages/Authentication/LogOut";
import UserProfile from "pages/Authentication/UserProfile";
import Settings from "pages/Pages/Settings";
import ManageOrders from "pages/ManageOrders/ManageOrders";
import ManageUser from "pages/ManageUser";
import DriverTasks from "pages/DriverTasks/DriverTasks";
import InspectorTasks from "pages/InspectorTasks/InspectorTasks";
import AITasks from "pages/AITasks/AITasks";
import { getRoleId, getTokenExpiration } from "Common/Components/getRoleId";
import BakerQuota from "pages/quota/BakerQuota";
import ViolationsReport from "pages/ViolationsReport/ViolationsReport";
import BakeryQuotasUpload from "pages/quota/BakeryQuotasUpload";
import ReportsPage from "pages/ReportsPage/ReportsPage";
import ReportsDecadePage from "pages/ReportsDecade/ReportsDecade";
import AdminSettings from "pages/AdminSettings/AdminSettings";
import BakeryInformation from "pages/BakeryInformation";

const TOKEN_MAX_AGE_MS = 55 * 60 * 1000;

const clearAuth = () => {
  localStorage.removeItem("app_havir");
  localStorage.removeItem("app_rt");
  localStorage.removeItem("login_time");
};

const isAuthValid = () => {
  const accessToken = localStorage.getItem("app_havir");
  const refreshToken = localStorage.getItem("app_rt");
  const loginTimeStr = localStorage.getItem("login_time");

  if (!accessToken || !refreshToken || !loginTimeStr) {
    clearAuth();
    return false;
  }

  const tokenExpiration = getTokenExpiration(accessToken);

  if (!tokenExpiration || tokenExpiration.getTime() <= Date.now()) {
    clearAuth();
    return false;
  }

  const loginTime = Number(loginTimeStr);

  if (!Number.isFinite(loginTime)) {
    clearAuth();
    return false;
  }

  if (Date.now() - loginTime > TOKEN_MAX_AGE_MS) {
    clearAuth();
    return false;
  }

  return true;
};

const Routepage = () => {
  const publicRoutes = [
    { path: "/login", component: Login },
    { path: "/logout", component: Logout },
    { path: "*", component: () => <Navigate to="/login" replace /> },
  ];

  if (!isAuthValid()) {
    return [[], publicRoutes] as const;
  }

  const accessToken = localStorage.getItem("app_havir");
  const userRole = getRoleId(accessToken);

  if (userRole === null || userRole === undefined) {
    clearAuth();
    return [[], publicRoutes] as const;
  }

  const defaultRouteByRole: Record<number, string> = {
    0: "/ManageOrders",
    1: "/ManageOrders",
    2: "/InspectorTasks",
    3: "/ManageOrders",
    4: "/DriverTasks",
    5: "/ManageOrders",
    6: "/ManageOrders",
  };

  const authProtectedRoutes = [
    {
      path: "/",
      component: () => (
        <Navigate to={defaultRouteByRole[userRole] || "/login"} replace />
      ),
      rolesAllowed: [0, 1, 2, 3, 4, 5, 6],
    },
    {
      path: "/ManageOrders",
      component: ManageOrders,
      rolesAllowed: [0, 1, 3, 5, 6, 7],
    },
    {
      path: "/AdminSettings",
      component: AdminSettings,
      rolesAllowed: [0],
    },

    {
      path: "/manageUser",
      component: ManageUser,
      rolesAllowed: [0, 1, 5, 6],
    },
    {
      path: "/DriverTasks",
      component: DriverTasks,
      rolesAllowed: [0, 1, 4, 5, 6, 7],   // اضافه شدن مدیر استان و مدیر شهرستان
    },
    {
      path: "/InspectorTasks",
      component: InspectorTasks,
      rolesAllowed: [0, 1, 2, 5, 6],
    },
        {
      path: "/BakeryInformation",
      component: BakeryInformation,
      rolesAllowed: [0, 1, 2, 5, 6],
    },
    
    {
      path: "/BakerQuota",
      component: BakerQuota,
      rolesAllowed: [0, 1, 2, 5, 6],
    },
    {
      path: "/BakeryQuotas/upload",
      component: BakeryQuotasUpload,
      rolesAllowed: [0, 1],   // فقط ادمین
    },
    {
      path: "/ViolationsReport",
      component: ViolationsReport,
      rolesAllowed: [0, 1, 2, 5, 6],
    },
    {
      path: "/reports",
      component: ReportsPage,
      rolesAllowed: [0, 1, 3, 5, 6, 7],
    },
    {
      path: "/ReportsDecadePage",
      component: ReportsDecadePage,
      rolesAllowed: [0, 1, 3, 5, 6, 7],
    },


    {
      path: "/AITasks",
      component: AITasks,
      rolesAllowed: [0, 1, 3, 5, 6],
    },
    {
      path: "/user-profile",
      component: UserProfile,
      rolesAllowed: [0, 1, 2, 3, 4, 5, 6],
    },
    {
      path: "/pages-account-settings",
      component: Settings,
      rolesAllowed: [0, 1],
    },
    {
      path: "*",
      component: () => (
        <Navigate to={defaultRouteByRole[userRole] || "/login"} replace />
      ),
      rolesAllowed: [0, 1, 2, 3, 4, 5, 6],
    },
  ];

  const filteredRoutes = authProtectedRoutes.filter((route) =>
    route.rolesAllowed.includes(userRole)
  );

  return [filteredRoutes, publicRoutes] as const;
};

export default Routepage;